import Vue from 'vue'
import VueI18n from 'vue-i18n'
// import enLocale from './element-ui/en'
// import zhLocale from './element-ui/zh-CN'
const LANGUAGES = {
  EN: 'en',
  ZH_CN: 'zh-cn',
}
/**后续把文件名按规则整理，无需此代码 */
const LANGUAGES_LOADER = {
  [LANGUAGES.EN]: () => [import('@/locale/element-ui/en.js'), import('@/locale/en.js')],
  [LANGUAGES.ZH_CN]: () => [
    import(/* webpackPreload: true */ '@/locale/element-ui/zh-CN.js'),
    import(/* webpackPreload: true */ '@/locale/zh_cn.js'),
  ],
}

function initLanguage() {
  if (window.location.href.includes('jjhqm')) {
    // 锦江系统只有中文
    return 'zh-cn'
  }
  if (window.location.href.includes('en-US')) {
    localStorage.setItem('VOC-LANGUAGE', 'en')
    // 根据URL判断
    return 'en'
  }
  if (localStorage.getItem('VOC-LANGUAGE')) {
    return localStorage.getItem('VOC-LANGUAGE')
  }
  if (navigator.language?.startsWith('en')) {
    localStorage.setItem('VOC-LANGUAGE', 'en')
    return 'en'
  }
  return 'zh-cn'
}

// const systemLanguage =
//   String.prototype.indexOf.call(navigator.language, LANGUAGES.EN) === 0 ? LANGUAGES.EN : LANGUAGES.ZH_CN
// const lang = window.location.href.includes('jjhqm') ? 'zh-cn' : localStorage.getItem('VOC-LANGUAGE') || systemLanguage

const lang = initLanguage()

// Vue.locale('zh-cn', {
//   ...require('./zh_cn'),
//   ...zhLocale,
// })

// Vue.locale('en', {
//   ...require('./en'),
//   ...enLocale,
// })
const i18nLangLoader = new Promise((resolve, reject) => {
  Promise.all(LANGUAGES_LOADER[lang]()).then(langs => {
    Vue.config.lang = lang
    // debugger
    Vue.locale(lang, Object.assign({}, Vue.locale(lang), langs[0].default, langs[1].default))
    resolve(Vue.config.lang)
  })
})

export default i18nLangLoader
